module.exports = __webpack_public_path__ + "static/media/md-walk.629f0c95.svg";